import { toast } from 'react-hot-toast';
import convertError from './error-converter.js';

async function showToastPromise(
    promise,
    { loading, success, duration = 3000 }
) {
    const toastId = 'getSystemRequirementsToast';
    return toast.promise(
        promise,
        {
            loading,
            success,
            error: (err) => {
                const converted = convertError(err);
                return converted.message;
            }
        },
        {
            id: toastId,
            success: { duration }, // example: 3s
            error: { duration: 5000 } // errors stay longer
        }
    );
}
export default showToastPromise;
